import { StreamActions } from "@hotwired/turbo";

// Un plan IA vient d'être réglé (Composition#broadcast_shot_settled). Aucun DOM à remplacer : le
// compositeur possède son document en mémoire — on diffuse l'issue comme un événement, il pose
// l'url (ou l'erreur) sur la séquence qui référence ce fichier.
StreamActions.composition_shot_settled = function () {
  let detail;
  try {
    detail = JSON.parse(this.getAttribute("detail"));
  } catch (e) {
    console.error("composition_shot_settled : JSON invalide", e);
    return;
  }

  window.dispatchEvent(new CustomEvent("composition-shot:settled", { detail }));
};
